import React from 'react';
import {matchPath, NavLink, useLocation} from 'react-router-dom';
import routes from "../../routes";
import * as queryString from 'query-string';
import { isPwa } from '../../fanctionUtility';


const Breadcrumbs = (props) => {

    const location = useLocation();
    // necessario utilizzare lo spread operator perché l'oggetto ritornato
    // dalla funzione queryString.parse() è un oggetto creato con Object.create(null)
    // e quindi senza il prototype di Object
    const objSearch = {...queryString.parse(location.search)};

    const {pathBreadcrumb} = props;
    const breadcrumbs = [];

    if (pathBreadcrumb) {
        pathBreadcrumb
            .split('/')
            .reduce((path, partOfPath) => {
                path = path === '/' ? `${path}${partOfPath}` : `${path}/${partOfPath}`;

                routes.filter(route => {
                    return matchPath( {path: route.path}, location.pathname) != null
                }).filter(route => {
                    return !breadcrumbs.includes(route.breadcrumb)
                }).forEach(e => {

                    breadcrumbs.push(e.breadcrumb);
                });

                return path;
            }, '');
    }

    const getSearchOrHash = (breadcrumbs) => {
        const route = routes.find(r => r.breadcrumb === breadcrumbs);
        const indexRoute = routes.map(r => r.breadcrumb).indexOf(breadcrumbs);

        if (route != null) {
            if (route.hasOwnProperty('search')) {
                const params = routes.filter(r => matchPath( {caseSensitive: true, path: r.path}, location.pathname))
                    .map(r => matchPath( {path: r.path}, location.pathname))[0];

                return createQuery(route.search, indexRoute, params.params, objSearch);
            } else if (route.hasOwnProperty('fragment')) {
                const objHash = {...queryString.parse(location.hash)};

                return createQuery(route.fragment, indexRoute, objHash);
            } else {
                    return null;
                }
        } else {
            return null;
        }
    }

    const createQuery = (searchFragEl, indexRoute, params, objSearchHash) => {
        if (typeof searchFragEl === 'string') {
            return searchFragEl;
        } else if (typeof searchFragEl === 'object') {
            Object.keys(searchFragEl)
                .forEach(keySearch => {
                    if (objSearchHash.hasOwnProperty(keySearch)) {
                        routes[indexRoute].search[keySearch] = objSearchHash[keySearch];
                    } else if (params.hasOwnProperty(keySearch)) {
                        routes[indexRoute].search[keySearch] = params[keySearch];
                    }
                });
            return queryString.stringify(routes[indexRoute].search);
        }
    }

    return (
        <div>
            <nav aria-label="breadcrumb" style={{pointerEvents: isPwa() ? 'none' : 'all'}}>
                <ol className="breadcrumb m-0">

                    {breadcrumbs.map((b, i) => (i !== breadcrumbs.length - 1) ? (
                        <li key={b} className="breadcrumb-item">
                            <NavLink to={{
                                pathname: routes.filter(r => r.breadcrumb === b)
                                    .map(r => matchPath({path: r.path}, pathBreadcrumb))[0]?.pathnameBase,
                                search: getSearchOrHash(b)
                            }} end>
                                {b}
                            </NavLink>
                        </li>
                    ) : (
                        <li key={b} className="breadcrumb-item active">
                            {b}
                        </li>
                    ))}

                </ol>
            </nav>
        </div>
    )
};


export default Breadcrumbs;
